<template>
  <section v-if="getActionAvailabilityFlag(ACTION_ENUM.CREATE_DISCUSSION)">
    <div v-if="!forceShowEditor && checkCommentAccess">
      <div
        class="d-flex w-100 border-top p-3 flex-row reply-discussion"
        v-if="!showEditor"
      >
        <div class="flex-grow-1 mr-3">
          <input
            :placeholder="placeholder"
            class="form-control form-control-sm reply-discussion-input"
            @focus="showEditor = true"
          />
        </div>
        <div v-if="discussion && showCloseBtn">
          <button
            type="button"
            class="btn btn-sm js-btn-discussion-close"
            :class="!discussion.note.resolved ? 'btn-outline-success' : 'btn-danger'"
            :disabled="discussion.note.resolved"
            @click.prevent="$emit('closeDiscussion', discussion)"
          >
            {{
              discussion.note.resolved
                ? $t('discussion_closed')
                : $tc('message.close', 1, { obj: $t('discussion_choose') })
            }}
          </button>
        </div>
      </div>
      <div v-show="showEditor">
        <gf-custom-text-editor
          class="mx-3 mb-3"
          editor-variant="editor"
          :has-close-button="true"
          :submit-button-text="$tc('message.comment', 1)"
          :closeOnUnfocus="true"
          placeholder="Ответ"
          @close="showEditor = false"
          @submit="submitDiscussion"
          @hide="showEditor = false"
        ></gf-custom-text-editor>
      </div>
    </div>
    <div v-else>
      <gf-custom-collapse
        v-if="checkCommentAccess"
        ref="collapsedCreateDiscussionForm"
        class="mt-3"
        :is-hided-toggle-after-opening="true"
        toggle-class="mx-auto width-fit-content"
      >
        <template #toggle>
          <div class="mx-auto">
            <div
              type="button"
              class="btn btn-primary btn-sm"
              data-editor="discussionMergeRequestEditor"
            >
              {{ $t('create_discussion_new') }}
            </div>
          </div>
        </template>
        <template #collapse>
          <div class="text-break">
            <div class="card">
              <div class="card-body bg-light rounded">
                <gf-custom-text-editor
                  editor-variant="editor"
                  ref="discussionMergeRequestEditor"
                  open-button-data-name="discussionMergeRequestEditor"
                  :is-opened="false"
                  :has-close-button="true"
                  :submit-button-text="$t('create_discussion_new')"
                  :close-on-unfocus="closeOnUnfocus"
                  placeholder="Напишите комментарий для дискуссии здесь"
                  @submit="submitDiscussion"
                  @close="$refs.collapsedCreateDiscussionForm.closeCollapse()"
                  @hide="handleClickOutside"
                ></gf-custom-text-editor>
              </div>
            </div>
          </div>
        </template>
      </gf-custom-collapse>
    </div>
  </section>
</template>

<script>
import { EventBus, EventEnums } from '@shared/event-bus';
import mergeRequestMessages from '@shared/modules/merge-request/mergeRequestMessages';
import GfCustomCollapse from '@/shared-modules/shared-components/shared/GfCustomCollapse.vue';
import GfCustomTextEditor from '@/shared-modules/shared-components/shared/GfCustomTextEditor.vue';
import ACTION_ENUM from '@shared/modules/custom-roles/custom-roles.constants';

export default {
  components: {
    GfCustomCollapse,
    GfCustomTextEditor
  },
  name: 'merge-request-discussion-reply-form',
  props: {
    discussion: {
      type: Object
    },
    placeholder: {
      default: 'Ответ...',
      type: String
    },
    forceShowEditor: {
      default: false,
      type: Boolean
    },
    autoFocus: {
      default: false,
      type: Boolean
    },
    closeOnUnfocus: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      showEditor: false,
      showCloseBtn: false,
      form: {},
      isEditorHided: false
    };
  },
  mounted() {
    this.showEditor = this.forceShowEditor;
    this.checkAccess();
    EventBus.$on(EventEnums.MERGE_REQUEST_DISCUSSION_REPLY_CREATED, this.closeEditor);
  },
  beforeDestroy() {
    EventBus.$off(EventEnums.MERGE_REQUEST_DISCUSSION_REPLY_CREATED);
  },
  computed: {
    ACTION_ENUM() {
      return ACTION_ENUM;
    },
    checkCommentAccess() {
      return document.querySelector('head meta[name="uuid"]');
    }
  },
  methods: {
    getActionAvailabilityFlag(action) {
      return this.$store.getters.getActionAvailabilityFlag(action);
    },
    async submitDiscussion(data) {
      let str = await data;
      this.form.reply = str;
      let regexp = /[^\s\r\n]+/;
      let result = regexp.test(str);
      if (!result) return false;
      if (str !== undefined) {
        this.$emit('submitReply', this.form.reply);
        this.form.reply = '';
        delete this.form.reply;
      }
    },
    closeEditor() {
      if (!this.forceShowEditor) {
        this.showEditor = false;
        // return;
      }
      if (this.form.reply && this.form.reply.trim()) {
        this.form.reply = '';
      }
    },
    checkAccess() {
      const metaUuid = document.querySelector('head meta[name="uuid"]');
      let uuid = '';
      let aid = '';
      if (metaUuid) {
        uuid = metaUuid.content;
        if (this.discussion) {
          aid = this.discussion.author.id;
        }
      }
      if (
        (uuid.length > 0 && uuid === aid) ||
        this.getActionAvailabilityFlag(ACTION_ENUM.RESOLVE_DISCUSSION)
      ) {
        this.showCloseBtn = true;
      }
    },
    handleClickOutside() {
      // this.showEditor = false;
      // this.$refs.collapsedCreateDiscussionForm.closeCollapse();
      $refs.collapsedCreateDiscussionForm.closeCollapse();
      this.$emit('hide');
    }
  },
  i18n: {
    messages: mergeRequestMessages
  }
};
</script>
